'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveState = exports.loadState = undefined;
var _lodash = require('lodash');
var loadState = exports.loadState = function loadState(version) {
  var useLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var storage = useLocalStorage ? localStorage : sessionStorage;
  if (window.location.search === '?c') {
    storage.clear();
  }
  try {
    var serializedState = storage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    var state = JSON.parse(serializedState);
    if (state.version !== version) {
      return undefined;
    }
    return state.state;
  } catch (err) {
    return undefined;
  }
};
var lastStoredState = void 0;
var saveState = exports.saveState = function saveState(store, version, stateToSave) {
  var useLocalStorage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var storage = useLocalStorage ? localStorage : sessionStorage;

  // If the state is undefined/null then the stateToSave can throw. In this
  // case use null as the state value instead so it gets cleared.
  var getStateToSave = function getStateToSave() {
    try {
      return stateToSave(store.getState());
    } catch (err) {
      return null;
    }
  };
  return store.subscribe(function () {
    var state = getStateToSave();
    if ((0, _lodash.isEqual)(state, lastStoredState)) {
      return;
    }
    try {
      storage.setItem('state', JSON.stringify({
        state: state,
        version: version
      }));
    } catch (err) {
      // Browser does not support localStorage - ignore
    }
    lastStoredState = state;
  });
};